import { SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { IObject } from "@quest/adapter-interface";




export let gameConstants: IObject = {
  GAME_CONTAINER_DIV: "gameContainer",

  SOUND_LIST_POSTLOAD: "soundList_1",
  SOUND_LIST_PRELOAD: "soundList",



  //symbol conversion
  //symbol conversion
  SYMBOL_FS_NO: 11, // 110 serverSymbolId or FS or scatter symbol
  SYMBOL_REVEAL_NO: 0, // 77 serverSymbolId or reveal symbol
  FREESPIN_WITHOUT_NUM: 20,
  MYSTERY_SYMBOL_NUMBER: 77,
  TWEEN_DELAY: "TWEEN_DELAY",
LOGO_EXTRA_SCALE : 1.3,
EXTRA_SPACE :0,

  //sound volume levels
  SOUND_VOL_POINT_3: 0.3,
  SOUND_VOL_POINT_4: 0.4,
  SOUND_VOL_1: 1,
  SYMBOL_NO: 10,
  GRAND_JP_METER_MULTIPLIER: 150,
  MAJOR_JP_METER_MULTIPLIER: 75,
  MINOR_JP_METER_MULTIPLIER: 40,
  MINI_JP_METER_MULTIPLIER: 20,
  WINTICKUP_22: 5,


    //big win threshold
  BigWinMultiplier: 10,
  SuperWinMultiplier: 20,
  EpicWinMultiplier: 50,
  CrazyWinMultiplier: 100,
  WIN_METER_OBJECT: "",

  //PORTRAIT EXTRA PIVOT FOR VIEWS(This is done bcs reelBG assets was not centrally aligned in the sprite)
  //reelBg carrying too much white/blank space in the asset due to which it was not getting align from proper center.
  EXTRA_PIVOT_X: 1,
  EXTRA_PIVOT_Y: 18,


  //ALPHA
  ALPHA_0: 0,
  ALPHA_1: 1,

  //DELAY
  TWEEN_POTION_DELAY: "TWEEN_POTION_DELAY",

  //fade symbols in anticipation
  FREESPIN_SYMBOL_GAME: 12,
  FADED_SYMBOL: 0x363636,
  UNFADED_SYMBOL: 0xffffff,

  TIMER_200: 200,
  WINTICKUP_BG_4: 4.3,

  // MINIMUM SCATTER LIMIT TO WIN FREE GAME
  SCATTER_TO_WIN_FG: 3,

  // SYMBOLS
  FREE_SPIN_SYMBOL: 12,
  POT_SYMBOL: 13,
  POT_SYMBOL_NAME: "spyglass_disable",
  FS_SYMBOL: "freespin",
  FS_SYMBOL_SC: 'fs',

  SEND_SHOW_NEXT_WIN_PRESENTATION_REQUEST: "sendShowNextPresentation",
  TIME_OUT_JP_CONVERSION: 2200,
  JACKPOT_BANNER_WITHOUT_MULTILPIER: 1,

  //DEC Currency
  REMOVE_VALUE_AFTER_DECIMAL_PALACE_ON_CURRENCY: ["DEC"],
  HelpPage: "HelpPageButton",
  SettingButton: "SettingButton",

  //Volumne
  LOW_VOLUME: 0,
  FULL_VOLUME: 1,
  NO_WIN: 0,
  BIG_WIN_MULTIPLIER: 10,
  SUPER_WIN_MULTIPLIER: 20,
  EPIC_WIN_MULTIPLIER: 50,
  CRAZY_WIN_MULTIPLIER: 100,

  BIG_WIN: 1,
  SUPER_WIN: 2,
  EPIC_WIN: 3,
  CRAZY_WIN: 4,
  //LOGO
  DISPLAY_BLOCK: "block",
  BOTTOM_BAR_HEIGHT: 46,

  GAME_LOGO_WIDTH: 680,
  GAME_LOGO_HEIGHT: 345,
  SCALE_PERCENT_MOBILE_IPad: 1.1,
  // Big Win, 
  SHOW_BIG_WIN_BLUR_BG: "SHOW_BIG_WIN_BLUR_BG",
  SHOW_SUPER_WIN_BLUR_BG: "SHOW_SUPER_WIN_BLUR_BG",
  SHOW_EPIC_WIN_BLUR_BG: "SHOW_EPIC_WIN_BLUR_BG",
  SHOW_CRAZY_WIN_BLUR_BG: "SHOW_CRAZY_WIN_BLUR_BG",
  // INTROOUTRO
  INTRO_HIDE_DELAY: "delayInIntroHiding",
  DURATION_300: 300,

  BUTTON_PANEL_BG_ALPHA: 0.6,
  REEL_BOTTOM_SPACE: -20,
  IPAD_MINI_ASPECT_RATIO: 1.52,
  REEL_BOTTOM_SPACE_LANDSCAPE: 0,
  IPAD_PRO_ASPECT_RATIO: 10 / 7,

};
SlotConstantsBehavior.GAME_NAME = "Pioneering Wins",
  (SlotConstantsBehavior.WrapperTopBarHeightDesktop = 32), (SlotConstantsBehavior.ADD_IN_Y = 90);
SlotConstantsBehavior.FONT_LIST = ["Arial", "ArialBlack", "MinionPro-Bold", "ArialBold", "ALBERTUSNOVABLACK"];
SlotConstantsBehavior.SCALE_PERCENT = 1;
SlotConstantsBehavior.VIEW_SLIDE_DESKTOP = 0;
SlotConstantsBehavior.VIEW_SLIDE_MOBILE = 0;
SlotConstantsBehavior.REEL_MAXSCALE_HEIGHT = 720;
SlotConstantsBehavior.SCALE_PERCENT_MOBILE = 1;
SlotConstantsBehavior.AutoPlayDelayBigWin = 200;
SlotConstantsBehavior.AutoPlayDelayWin = 200;
SlotConstantsBehavior.BASEGAME_IDLE_SPINE="basegame_idle_desktop"
